// src/components/Visualizer/Visualizer.tsx
import React from 'react';
import './Visualizer.css';

interface VisualizerProps {
  decibels: number;
}

export function Visualizer({ decibels }: VisualizerProps): JSX.Element {
  let color = 'green';
  if (decibels < 70) color = 'green';
  else if (decibels >= 70 && decibels < 100) color = 'yellow';
  else if (decibels >= 100 && decibels < 125) color = 'orange';
  else if (decibels >= 125 && decibels < 150) color = 'purple';
  else color = 'red';

  return (
    <div
      id="visuals"
      className="visuals"
      style={{
        width: `${(decibels * 2) / 10}rem`,
        backgroundColor: color,
        color,
      }}
    />
  );
}

export default Visualizer;
